module.exports = __webpack_public_path__ + "static/media/logo_cuc_vertical.760858c3.png";